var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJpeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 701,
    viewBox: "0 0 501 701",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M438.501 1.00087H138.501C136.861 0.980888 135.236 1.30421 133.729 1.95005C132.222 2.59588 130.867 3.54994 129.751 4.75088L4.75088 129.751C3.54994 130.867 2.59588 132.222 1.95004 133.729C1.3042 135.236 0.980888 136.861 1.00087 138.501V638.501C1.00087 655.077 7.58568 670.974 19.3067 682.695C31.0277 694.416 46.9248 701.001 63.5009 701.001H438.501C455.077 701.001 470.974 694.416 482.695 682.695C494.416 670.974 501.001 655.077 501.001 638.501V63.5009C501.001 46.9248 494.416 31.0277 482.695 19.3067C470.974 7.58568 455.077 1.00087 438.501 1.00087Z",
    fill: "url(#paint0_linear_2267_442)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.359 1.04767C141.106 0.02656 138.588 -0.257327 136.164 0.236459C133.74 0.730245 131.533 1.97651 129.859 3.79766L4.8589 128.798C2.64467 130.401 1.05877 132.726 0.374284 135.373C-0.310196 138.019 -0.0504147 140.822 1.1089 143.298C2.10581 145.745 3.85262 147.813 6.09846 149.206C8.34431 150.598 10.9737 151.243 13.6089 151.048H88.6089C96.8165 151.048 104.944 149.431 112.527 146.29C120.109 143.149 126.999 138.546 132.803 132.742C138.607 126.938 143.21 120.048 146.351 112.465C149.492 104.883 151.109 96.7553 151.109 88.5477V13.5477C151.304 10.9124 150.659 8.28308 149.267 6.03723C147.874 3.79139 145.806 2.04458 143.359 1.04767Z",
    fill: "url(#paint1_linear_2267_442)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M396.512 425.399L349.561 315.747C333.661 278.546 304.41 277.046 284.76 312.447L256.409 363.597C242.009 389.548 215.159 391.798 196.558 368.548L193.258 364.347C173.908 340.047 146.607 343.047 132.657 370.798L106.857 422.549C88.7063 458.549 114.957 501 155.157 501H346.561C385.562 501 411.812 461.249 396.512 425.399Z",
    stroke: "white",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M175.855 291.002C200.708 291.002 220.856 270.854 220.856 246.001C220.856 221.148 200.708 201 175.855 201C151.002 201 130.854 221.148 130.854 246.001C130.854 270.854 151.002 291.002 175.855 291.002Z",
    stroke: "white",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2267_442",
    x1: 17.2509,
    y1: 117.251,
    x2: 532.751,
    y2: 632.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7EC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2267_442",
    x1: 1.1089,
    y1: 76.0477,
    x2: 151.109,
    y2: 76.0477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC7EC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E056A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpeg);
export default __webpack_public_path__ + "static/media/jpeg.4387060816907bee142d781608c2b67f.svg";
export { ForwardRef as ReactComponent };